// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var PromoCodeStatus = function (x) {
    return x;
};
var tsBridgePromoCodeStatus = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("PromoCodeStatus")("__brandPromoCodeStatus"));
    }
};
var writePromoCodeStatus = Simple_JSON.writeForeignString;
var unwrap = function (v) {
    return v;
};
var showPromoCodeStatus = Data_Show.showString;
var readPromoCodeStatus = Simple_JSON.readString;
var ordPromoCodeStatus = Data_Ord.ordString;
var newtypePromoCodeStatus = {
    Coercible0: function () {
        return undefined;
    }
};
var makePromoCodeStatus = PromoCodeStatus;
var eqPromoCodeStatus = Data_Eq.eqString;
export {
    PromoCodeStatus,
    makePromoCodeStatus,
    unwrap,
    newtypePromoCodeStatus,
    eqPromoCodeStatus,
    ordPromoCodeStatus,
    showPromoCodeStatus,
    readPromoCodeStatus,
    writePromoCodeStatus,
    tsBridgePromoCodeStatus
};
//# sourceMappingURL=index.js.map
